module.exports = __webpack_public_path__ + "img/dash_kegiatan.16a75250.png";